import styled, { keyframes } from 'styled-components';

interface ProgressBarProps {
  progress: number;
  title: string;
  subtitle: string;
}

export const ProgressBar = ({ progress, title, subtitle }: ProgressBarProps) => {
  return (
    <ProgressSection>
      <ProgressText>{title} {Math.round(progress)}%</ProgressText>
      <ProgressBarContainer>
        <ProgressBarFill progress={progress} />
      </ProgressBarContainer>
      <ProgressSubtext>{subtitle}</ProgressSubtext>
    </ProgressSection>
  );
};

// Styled Components
const ProgressSection = styled.div`
  margin: 1.5rem 0;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.gray}20;
  border-radius: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.gray500}20;
`;

const ProgressText = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  margin-bottom: 1rem;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 12px;
  background: ${({ theme }) => theme.colors.gray500}20;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 0.75rem;
`;

const ProgressBarFill = styled.div<{ progress: number }>`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background: linear-gradient(90deg, 
    ${({ theme }) => theme.colors.primary}, 
    ${({ theme }) => theme.colors.primary}CC
  );
  border-radius: 6px;
  transition: width 0.3s ease;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, 
      transparent, 
      rgba(255, 255, 255, 0.3), 
      transparent
    );
    animation: shimmer 2s infinite;
  }
  
  @keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
`;

const ProgressSubtext = styled.div`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.gray900};
  text-align: center;
  font-style: italic;
`;
